var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildingsAlt3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.292 22H20C21.1046 22 22 21.1073 22 20.0062V13.0281C22 11.927 21.1046 11.0343 20 11.0343H14.5V21.0031C14.5 21.3576 14.4258 21.6947 14.292 22Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.48317 2.88108C2.19309 2.98623 2 3.26105 2 3.56874V21.0031C2 21.5537 2.44772 22 3 22H12C12.5523 22 13 21.5537 13 21.0031V3.56874C13 3.26105 12.8069 2.98623 12.5168 2.88108C9.27609 1.70631 5.72392 1.70631 2.48317 2.88108ZM5 22V18.5109C5 17.1345 6.11929 16.0187 7.5 16.0187C8.88071 16.0187 10 17.1345 10 18.5109V22H5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingsAlt3);
export default __webpack_public_path__ + "static/media/buildings-alt-3.24b4d543bbffac09a2b4df61ed080461.svg";
export { ForwardRef as ReactComponent };